export default "__VITE_ASSET__CDypkCBK__"